<template>
  <div class="com">
    <div class="details">
      <div class="title">
        Purchaser Details
      </div>
      <div class="field" v-if="kit.collected_first_name !== null">
        {{ kit.collected_first_name }} {{ kit.collected_last_name }}
      </div>
      <div class="field" v-else>
        <span>No Data</span>
      </div>
      <div class="field" v-if="kit.collected_phone !== null">
        <span v-if="kit.collected_phone !== null">{{
          makePhone(kit.collected_phone)
        }}</span>
      </div>
      <div class="field" v-else>
        <span>No Data</span>
      </div>
      <div class="field email">
        <input
          type="text"
          v-model="emailInput"
          @click="checkInput"
          @input="sendProp"
          name="collected_email_admin"
          v-validate="'email'"
          placeholder="Email"
          :readonly="readonly"
        />
        <span class="validate-error" v-if="errors.has('collected_email_admin')">
          {{ errors.first("collected_email_admin") }}
        </span>
      </div>
      <!-- V2: address from nested address object -->
      <div class="field email-edit" v-if="addressDisplay">
        {{ addressDisplay }}
      </div>
      <div class="field" v-else>
        No Data
      </div>
      <div class="field email-edit" v-if="kit.address && kit.address.zip">
        {{ kit.address.zip }}
      </div>
      <div class="field" v-else>
        No Data
      </div>
      <!-- V2 kits don't have woo order numbers -->
      <div class="field" v-if="kit.order_number !== null && kit.order_number !== undefined">
        Order #: {{ kit.order_number }}
      </div>
      <div class="field" v-else>
        No Order Data
      </div>
      <button class="btn" @click.stop="otherKits" v-show="!show">
        Other Kits of Customer
      </button>
    </div>
    <div class="title user" v-show="!show">
      User Details
    </div>
    <div class="field down email-edit" v-show="!show" v-if="user !== null">
      <span class="input-field" v-if="showEdit">
        <input
          type="text"
          class="input"
          v-validate="'required|max:50'"
          placeholder="First Name"
          name="userFirstName"
          maxlength="50"
          @change="changeVal('userFirstName', $event)"
          v-model="userFirstName"
        />
        <span class="validate-error" v-if="errors.has('userFirstName')">
          {{ errors.first("userFirstName") }}
        </span>
        <input
          type="text"
          class="input"
          v-validate="'required|max:50'"
          placeholder="Last Name"
          name="userLastName"
          maxlength="50"
          @change="changeVal('userLastName', $event)"
          v-model="userLastName"
        />
        <span class="validate-error" v-if="errors.has('userLastName')">
          {{ errors.first("userLastName") }}
        </span>
      </span>
      <span v-else>{{ user.first_name }} {{ user.last_name }}</span>
    </div>
    <div class="field down" v-show="!show" v-else>
      No Data
    </div>
    <div class="field down email-edit" v-show="!show" v-if="user !== null">
      <span class="input-field" v-if="showEdit">
        <input
          type="text"
          v-mask="'(###) ### - ####'"
          class="input"
          placeholder="Mobile Phone"
          name="phone"
          v-validate="
            'regex:^\\(([0-9]{3})\\)\\s([0-9]{3})\\s[-]\\s([0-9]{4})$|required'
          "
          v-model="userPhone"
        />
        <span class="validate-error" v-if="errors.has('phone')">
          {{ errors.first("phone") }}
        </span>
      </span>
      <span v-else>
        <p class="column-text" :class="{ phone_number: user.confirmed_phone }">
          {{ makePhone(user.phone) }}
        </p>
      </span>
    </div>
    <div class="field down" v-show="!show" v-else>
      No Data
    </div>
    <div class="field email-edit down" v-show="!show">
      <span class="input-field" v-if="user !== null && showEdit">
        <input
          type="text"
          class="input toLowerCase"
          placeholder="Email"
          name="email"
          v-validate="`required|email`"
          v-model="userEmailInput"
        />
        <span class="validate-error errormes" v-if="errors.has('email')">
          {{ errors.first("email") }}
        </span>
      </span>
      <span readonly v-else-if="user !== null">
        <p class="column-text" :class="{ email_address: user.confirmed_email }">
          {{ user.email }}
        </p>
      </span>
      <span readonly v-else>No Data</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ModalInfoV2",
  props: ["show", "showEdit"],
  data() {
    return {
      user: null,
      kit: {},
      kit_id: "",
      emailInput: "",
      userEmailInput: "",
      userLastName: "",
      userFirstName: "",
      userPhone: "",
      readonly: true
    };
  },
  computed: {
    ...mapGetters(["getTestKitInfoV2", "getUserInfoV2"]),
    addressDisplay() {
      if (!this.kit || !this.kit.address) return null;
      const a = this.kit.address;
      if (a.city && a.state) return `${a.city} ${a.state}`;
      return null;
    }
  },
  methods: {
    changeVal(model, e) {
      this[model] = e.target.value;
    },
    sendProp() {
      this.$emit("sendProp", {
        firstName: this.kit.collected_first_name,
        lastName: this.kit.collected_last_name,
        email: this.emailInput
      });
    },
    checkInput() {
      const status = this.statusOf(this.kit.status);
      if (status === "shipped") {
        this.readonly = false;
      }
    },
    otherKits() {
      this.$emit("otherKits", true);
    },
    saveSubmit() {
      let data = {
        firstName: this.kit.collected_first_name,
        lastName: this.kit.collected_last_name,
        email: this.emailInput,
        testkit: {
          kit_id: this.kit_id,
          user: {
            email: this.userEmailInput ? this.userEmailInput.toLocaleLowerCase() : "",
            last_name: this.userLastName,
            first_name: this.userFirstName,
            phone: this.userPhone ? `1${this.userPhone.replace(/[\s-()+]/g, "")}` : ""
          }
        }
      };
      this.$emit("editData", data);
    },
    statusOf(s) {
      if (typeof s === "string") return s;
      const map = {
        0: "shipped", 1: "activated", 2: "lab_awaiting", 3: "lab_received",
        4: "on_hold", 5: "analysis_completed", 6: "problem", 7: "delivered",
        8: "archive", 9: "returned", 10: "analysis_failed", 11: "partially_failed", 12: "in_active"
      };
      return map[s] || "shipped";
    },
    makePhone(phone) {
      if (phone === null || phone === undefined) return "No Data";
      const cleanPhone = phone.replace(/\D/g, "");
      if (cleanPhone.length === 11 || cleanPhone.length === 10) {
        const p = cleanPhone.split("");
        if (cleanPhone.length === 11) {
          return `(${p[1]}${p[2]}${p[3]}) ${p[4]}${p[5]}${p[6]}-${p[7]}${p[8]}${p[9]}${p[10]}`;
        } else {
          return `(${p[0]}${p[1]}${p[2]}) ${p[3]}${p[4]}${p[5]}-${p[6]}${p[7]}${p[8]}${p[9]}`;
        }
      }
      return "No Data";
    },
    async validate() {
      return this.$validator.validateAll();
    }
  },
  watch: {
    errors: {
      deep: true,
      handler(errorsNew) {
        this.$emit("emailError", errorsNew);
      }
    },
    userEmailInput() { this.saveSubmit(); },
    userFirstName() { this.saveSubmit(); },
    userLastName() { this.saveSubmit(); },
    userPhone() { this.saveSubmit(); },
    getTestKitInfoV2(obj) {
      if (obj) this.kit = obj;
    },
    getUserInfoV2(obj) {
      if (obj !== null) this.user = obj;
    }
  },
  inject: ["$validator"],
  created() {
    if (this.$store.getters.getUserInfoV2 !== null) {
      this.user = this.$store.getters.getUserInfoV2;
      if (this.user.email) this.userEmailInput = this.user.email;
      if (this.user.last_name) this.userLastName = this.user.last_name;
      if (this.user.first_name) this.userFirstName = this.user.first_name;
      if (this.user.phone) this.userPhone = this.makePhone(this.user.phone);
    }
    this.kit = this.$store.getters.getTestKitInfoV2 || {};
    if (this.kit.id) this.kit_id = this.kit.id;
    if (this.kit.collected_email) this.emailInput = this.kit.collected_email;
  }
};
</script>

<style scoped>
.com {
  height: 100%;
  padding: 15px;
  max-width: 340px;
  width: 100%;
  background-color: #03409a;
}
.details {
  background-color: #005eb8;
  border-radius: 10px;
  padding: 15px 15px 20px 15px;
}
.title {
  padding: 20px 0 20px 0;
  text-align: center;
  color: #fff;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
}
.title.user {
  padding: 20px 0 20px 0;
}
.field {
  width: 100%;
  height: 40px;
  background-color: #053c91;
  margin: 0 0 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  position: relative;
  font-family: TTNormsLight, sans-serif;
}
.input-field {
  width: 100%;
  background-color: #a8a8a8b6;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000000;
  font-size: 14px;
  position: relative;
  font-family: TTNormsLight, sans-serif;
}
.field.down {
  background-color: #073884;
  width: 280px;
  margin: 0 auto 20px auto;
}
.field a {
  color: #fff;
}
.btn {
  color: #fff;
  border: 1px solid #053c91;
  box-shadow: 0px 0px 20px 0px rgba(5, 60, 145, 1);
  border-radius: 30px;
  width: 245px;
  margin: 25px auto 0 auto;
  outline: none;
  cursor: pointer;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #005eb8;
}
.field.email input {
  height: 40px;
  width: 100%;
  background-color: transparent;
  outline: none;
  border: 1px solid transparent;
  color: #ffffff;
  text-align: center;
  cursor: default;
  padding: 0 10px;
  font-size: 14px;
  font-family: TTNormsMedium, sans-serif;
}
.field.email-edit input {
  height: 40px;
  width: 100%;
  background-color: transparent;
  outline: none;
  border: 1px solid transparent;
  color: #080808;
  text-align: center;
  cursor: default;
  padding: 0 10px;
  font-size: 14px;
  font-family: TTNormsMedium, sans-serif;
}
.input {
  border-radius: 10px;
  padding: 15px 20px;
  color: #373737;
  width: 285px;
  font-size: 16px;
  border: 1px solid #cccccc;
  text-align: center;
  outline: none;
  margin: 0;
  font-family: TTNormsMedium, sans-serif;
}
@media (max-height: 790px) {
  .com {
    overflow-y: scroll;
  }
  .com::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }
}
@media print {
  .com {
    display: none;
  }
}
.left-space {
  margin-left: 5px;
}
.errormes {
  padding-top: 10px;
}
</style>
<style scoped lang="scss">
.email_address,
.phone_number {
  position: relative;
  &:after {
    content: "";
    position: absolute;
    display: block;
    top: -4px;
    right: -30px;
    width: 24px;
    height: 24px;
    background: url("../../images/home/verfication-border.png") center no-repeat;
    background-size: 15px;
    cursor: pointer;
  }
  &:hover::before {
    content: "Verified";
    position: absolute;
    display: block;
    top: 2px;
    right: -75px;
    color: #ffffff;
    font-size: 11px;
    font-family: TTNormsMedium, sans-serif;
  }
}
</style>
